<script setup>
import { Link, usePage } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'

const page = usePage()

const logoSrc = computed(() => page.props.value.app.logoSrc)
</script>

<template>
  <Link v-if="logoSrc" href="/">
    <img
      :src="logoSrc"
      alt="Logo"
      class="block h-28 w-56 max-w-full object-contain"
    />
  </Link>
</template>
